module.exports = __webpack_public_path__ + "static/media/art1.a39ce0e2.png";